// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type PartialPaymentFragment = { __typename?: 'PartialPaymentDTO', amount: number, date: LocalDate, id: number, invoiceId: number | null, notes: string | null, paymentId: number | null, username: string | null };

export const PartialPaymentFragment = gql`
    fragment PartialPayment on PartialPaymentDTO {
  amount
  date
  id
  invoiceId
  notes
  paymentId
  username
}
    `;
/* eslint-enable */